module.exports = __webpack_public_path__ + "img/thumbnail-4@2x.bc5a5fb2.jpg";